import React from 'react';
import { motion } from 'framer-motion';
import { TargetIcon, TelescopeIcon } from 'lucide-react';
export function MissionVision() {
  return <section className="bg-white py-24 md:py-32 px-6" data-id="element-116">
      <div className="max-w-7xl mx-auto" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-118">
          <span className="text-[#c9a961] text-[13px] font-bold tracking-[0.2em] uppercase mb-4 block" data-id="element-119">
            Our Purpose
          </span>
          <h2 className="font-display text-[40px] md:text-[56px] font-medium text-[#1d1d1f] mb-6" data-id="element-120">
            Mission & Vision
          </h2>
          <div className="w-20 h-[1px] bg-[#c9a961] mx-auto mb-8" data-id="element-121" />
          <p className="text-[#86868b] text-[18px] md:text-[20px] max-w-3xl mx-auto font-light" data-id="element-122">
            Guided by our commitment to excellence and cultural authenticity
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-10" data-id="element-123">
          {/* Mission */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.1
        }} className="bg-[#faf8f5] p-12 border border-[#f0ebe3] hover:border-[#c9a961]/30 transition-all duration-500" data-id="element-124">
            <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center mb-8 shadow-sm border border-[#f0ebe3]" data-id="element-125">
              <TargetIcon className="w-8 h-8 text-[#c9a961]" data-id="element-126" />
            </div>
            <h3 className="font-display text-[32px] font-medium text-[#1d1d1f] mb-6" data-id="element-127">
              Our Mission
            </h3>
            <p className="text-[#86868b] text-[17px] leading-[1.8] font-light" data-id="element-128">
              To create exceptional dining experiences that celebrate the rich
              culinary traditions of India and Thailand, while fostering
              cultural understanding and appreciation through food. We are
              committed to using authentic ingredients, traditional techniques,
              and innovative presentations to delight our guests and exceed
              their expectations.
            </p>
          </motion.div>

          {/* Vision */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-[#faf8f5] p-12 border border-[#f0ebe3] hover:border-[#c9a961]/30 transition-all duration-500" data-id="element-129">
            <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center mb-8 shadow-sm border border-[#f0ebe3]" data-id="element-130">
              <TelescopeIcon className="w-8 h-8 text-[#c9a961]" data-id="element-131" />
            </div>
            <h3 className="font-display text-[32px] font-medium text-[#1d1d1f] mb-6" data-id="element-132">
              Our Vision
            </h3>
            <p className="text-[#86868b] text-[17px] leading-[1.8] font-light" data-id="element-133">
              To be recognized as the premier hospitality group in Thailand,
              known for our authentic Indian cuisine, exceptional service, and
              immersive cultural experiences. We aspire to expand our presence
              throughout Southeast Asia, introducing more people to the diverse
              flavors and traditions of Indian cuisine while maintaining the
              highest standards of quality and authenticity.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}